module.exports = __webpack_public_path__ + "img/trainingbrochuresmall-200x155-min.660030ce.jpg";